import { styled } from "sharedUI/styles";
import { SplitContainer } from "../../views/split-container/split-container";

export const EnumSliderStyle = styled(SplitContainer)`
    margin: 16px 0;
`;

export const SliderWrapper = styled.div<{ horizMargin: number }>`
    padding: 0 ${p => p.horizMargin}px;

    .rc-slider-rail {
        opacity: 0.25;
        background-color: ${p => p.theme.n600A};
    }

    .rc-slider-track {
        background-color: ${p => p.theme.blue};
    }

    .rc-slider-dot.rc-slider-dot-active {
        border-color: ${p => p.theme.blue};
    }

    .rc-slider-dot {
        border-color: ${p => p.theme.bgColorMedium};
    }

    .rc-slider-handle {
        border-color: ${p => p.theme.white};
        background: ${p => p.theme.white};
        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.33), 0px 1px 3px rgba(0, 0, 0, 0.25);
    }

    .rc-slider-handle-click-focused {
        border-color: ${p => p.theme.white};
        background: ${p => p.theme.white};
    }

    .rc-slider-handle:active {
        border-color: ${p => p.theme.white};
        background: ${p => p.theme.white};
    }

    .rc-slider-handle:hover {
        border-color: ${p => p.theme.white};
        background: ${p => p.theme.white};
    }

    .rc-slider-handle:focus {
        border-color: ${p => p.theme.white};
        background: ${p => p.theme.white};
    }
`;
